export const ROUTES = {
  LOGIN: '/login',
  OVERVIEW: '/overview',
  QUEUES: '/queues',
  USERS: '/users',
  PRODUCTS: '/products',
  SUBSCRIPTIONS: '/subscriptions',
  SECURITY: '/security',
  COOLDOWN_ACCOUNTS: '/cooldown-accounts',
  IP_BLOCKS: '/ip-blocks',
} as const;
